<template>
    
    <div>
        <div class="all">
            <div class="=title">
                <p class="h1" v-cloak>{{title}}</p>
            </div>
            <div class="radio">
                <el-input v-model="unm" placeholder="18313975762"></el-input>
                <el-input v-model="pwd" placeholder="654321"></el-input>
            </div>  
            <div class="button">
                <el-row>          
                    <el-button type="primary" @click="upload" :loading="loadingButton">{{loadingButtonText}}</el-button>
                </el-row>

            </div>
            
        </div>
        <div>
            <div id="uesrtext">

        <textarea placeholder="按 Ctrl + Enter 发送" v-model="content"></textarea>
             <el-row>          
                    <el-input v-model="phone" placeholder="18313975762"></el-input>
                </el-row>
                 <el-row>          
                    <el-button type="primary" @click="addMessage">发送</el-button>
                </el-row>
    </div>
    <div>
<el-row>          
                    <el-button type="primary" @click="detail">登录</el-button>
                </el-row>

    </div>
        </div>
       
    </div>
</template>
<script>
import {Message} from 'element-ui';
import SockJS from 'sockjs-client';
import Stomp from 'stompjs';

export default {
    
name:"version",
    data(){
        return {
            title:"项目更新",
            radio: 1,
            content:'',
            unm:'18313975762',
            pwd:'123456',
            loadingButton:false,
            colorAdmin:"",
            colorApp:"",
            stompClient:{},
            colorDist:"",
            colorTool:"",
            colorH:"",
            phone:"",
            toUserId:0,
            userId:window.sessionStorage.getItem("userId"),
            username:window.sessionStorage.getItem("user"),
            loadingButtonText:'去你的吧',
            runLog:[],
            params:{}
        }
    },
    methods:{
        upload(){
            let self = this
            self.params.phone = self.unm;
            self.params.password = self.pwd;
   
          
           self.loadingButton=true;
           self.loadingButtonText='正去着呢，请稍等..........';
            this.postRequest('/user/login_by_pwd',self.params).then(resp =>{
                 self.loadingButton=false;
                 self.loadingButtonText='去你的吧';
                  window.sessionStorage.setItem("user", JSON.stringify(resp.data.phone));
                   window.sessionStorage.setItem("userId", JSON.stringify(resp.data.userId));
            })

        }, 
   
        //初始化
            initWebSocket(){
                
                this.connection();

            },
            //建立连接
            connection() {
                // 建立连接对象
                //连接服务端提供的通信接口，连接以后才可以订阅广播消息和个人消息
                let _that=this;
                //后台服务ip和porthttps://apitest.hooply.com
                _that.socket = new SockJS('http://localhost:8056/ws/ep?aaaaaaaaa=1');
              //_that.socket = new SockJS('https://apitest.hooply.com/ws/ep');
                // 获取STOMP子协议的客户端对象
                _that.stompClient = Stomp.over(_that.socket);
                 //_that.stompClient.debug = null 
            

        // _that.stompClient.connect({"user":"1001",'type':1}, success => {
            _that.stompClient.connect({"user":"1001",'type':1}, success => {
                 _that.stompClient.subscribe('/user/queue/chat', msg => {
                     console.log("msg:",msg)
                    let receiveMsg = JSON.parse(msg.body);
                   
                    console.log("receiveMsg："+JSON.stringify(receiveMsg))
                 
                })
            }, error => {

            });


              
            },
            disconnect() {
                if (this.stompClient != null) {
                    this.stompClient.disconnect();
                 
                }
            },
       
        //销毁页面之前，断开连接
        beforeDestroy: function () {
            //页面离开时断开连接,清除定时器
            this.disconnect();
            clearInterval(this.timer);
        },
        mounted(){
            //调用初始化websocket方法
    
        },
       
        addMessage() {
               
                    let msgObj = new Object();
                    msgObj.toUserId =  this.phone;
                  //  msgObj.fromUserPhone = 18313975762;
                    msgObj.chatMsg = this.content;
                  
                    this.stompClient.send('/ws/chat', {}, JSON.stringify(msgObj));
             
            },
             //getMsg(){
            //    this.stompClient.subscribe('/user/queue/chat', msg => {
            //        let receiveMsg = JSON.parse(msg.data);
                   
             //       console.log("receiveMsg："+receiveMsg)
          //  })
       // },
        detail(){
             this.postRequest('/user/info',self.params).then(resp =>{
                 self.loadingButton=false;
                 self.loadingButtonText='去你的吧';
                  window.sessionStorage.setItem("user", JSON.stringify(resp.data.phone));
                  console.log("this.username:"+this.username);
            })
        },
        loginAnonymous(){
             this.postRequest('/user/login_anonymous',self.params).then(resp =>{
                 self.loadingButton=false;
                 self.loadingButtonText='去你的吧';
                window.sessionStorage.setItem("user", JSON.stringify(resp.data.phone));
                console.log("this.username:"+this.username);
                console.log("resp.error:"+resp.err);
                if(resp.err === 0){
                    this.initWebSocket();
                }
                  
            })
        }
    },
    
    created() {
      //  this.loginAnonymous();
      this.initWebSocket();
     // window.localStorage.setItem('aaa',2)
    //this.userId = window.localStorage.getItem('aaa');
    },
    destroyed() {
      this.websock.close();//离开路由之后断开websocket连接
    }
}
</script>
<style>
    .infinite-list{
        border: rgba(92, 48, 145, 0.04);
       margin-top: 1%;
       margin-left: 10%;
    }
    .alal{
      background-image: url(../../assets/1231232.jpg);
        
    }
    .all{
       box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }
   
    .h1{
        font-style: initial;
        font-size: 50px;
    }
    .button{
        margin-top: 1%;
        margin-left: 20%;
    }
</style>